<div class="dashboardPanel" style="overflow-x: hidden;overflow-y: auto;">
<app-scrum-bread-bar></app-scrum-bread-bar>
<div class="card-container">
	<div class="card" *ngFor="let tile of filterTiles('OrderStatus')" [style.border-color]="tile.Background" (click)="showOrdersList(tile.StatusId, tile.CountryId)">
		<div class="title" [style.background]="tile.Background"> 
			<div style="margin-top:3px; float: left;display: inline-block;"> {{ tile.Title }} </div>
			<div class="icon"> <img src="{{'../../../../assets/images/flags/' + tile.Icon }}" /></div>
		</div>
		<div class="content" [style.color]="tile.Background">{{ formatOrderCount(tile.OrderCount, ',')}}</div>
		<!-- <mat-progress-bar [style.color]="tile.Background" mode="determinate" [value]="tile.OrderCount"></mat-progress-bar> -->
		<div class="w3-light-grey" style="background: lightgrey">
		  <div class="w3-green" [style.background]="tile.Background" [style.width]="((tile.OrderCount / tile.TotalCount) * 100) + '%'" style="height:2px;"></div>
		</div>
		<div class="footer">
			<div style="float:left;display: inline;" [style.color]="tile.Background"> {{translations.lblTotalCount}} : {{ formatOrderCount(tile.TotalCount, ',') }}</div>
			<a *ngIf="tile.OrderCount > 0" (click)="showOrdersList(tile.StatusId, tile.CountryId)" href="javascript:;" mat-flat-button [style.color]="tile.Background">
				{{translations.lblTileLink}}	
			</a>
			<a *ngIf="tile.OrderCount == 0" disabled href="javascript:;" mat-flat-button [style.color]="tile.Background">
				&nbsp;	
			</a>
		</div>
	</div>
	<!-- <div class="chart-container" *ngIf="filterTiles('Graph').length == 1"> -->
		<app-order-chart *ngIf="filterTiles('Graph').length == 1" [translations]="translations"></app-order-chart>
	<!-- </div> -->
</div>
</div>





// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/dashboard/dashboard.component.html